import React from 'react';
import { useEditor } from '@craftjs/core';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Toolbox } from './Toolbox';

const useStyles = makeStyles((theme) => ({
  viewport: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  pageContainer: {
    display: 'flex',
    flex: 1,
    height: '100%',
    flexDirection: 'column',
  },
  craftRenderer: {
    flex: 1,
    height: '100%',
    width: '100%',
    overflow: 'auto',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    '& .component-selected': {
      outline: `2px solid ${theme.palette.primary.main}`,
      boxShadow: `0px 0px 10px 0px ${theme.palette.primary.light}`,
      outlineOffset: '1px',
      zIndex: 1299,
    }
  },
  contentWrapper: {
    width: '210mm',
    minHeight: '297mm',
    backgroundColor: 'white',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    margin: 'auto',
    padding: 0,
  },
}));

export const Viewport = ({ children, templateName, onNameChange, onSave, isSaving, isLoading, isDuplicable, onDuplicableChange, isGlobal, onGlobalChange, isSuperadmin, }) => {
  const { enabled, connectors, actions: { setOptions } } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const classes = useStyles({ enabled });

  return (
    <Box className={classes.viewport}>
      <Toolbox />

      <Box className={classes.pageContainer}>
        <Header 
          templateName={templateName}
          onNameChange={onNameChange}
          onSave={onSave}
          isSaving={isSaving}
          isLoading={isLoading}
          isDuplicable={isDuplicable} 
          onDuplicableChange={onDuplicableChange}
          isGlobal={isGlobal} 
          onGlobalChange={onGlobalChange}
          isSuperadmin={isSuperadmin}
        />
        <Box
          className={classes.craftRenderer}
          ref={(ref) => connectors.select(connectors.hover(ref, null), null)}
        >
          <div className={classes.contentWrapper}>
            {children}
          </div>
        </Box>
      </Box>

      <Sidebar />
    </Box>
  );
};